'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Calendar, LogIn } from 'lucide-react';

const navLinks = [
  { label: 'Book a Service', href: '/' },
  { label: 'My Bookings', href: '/sign-up-login' },
];

export default function CustomerTopbar() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-card border-b border-border shadow-card">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 flex-shrink-0">
          <AppLogo size={36} />
          <span className="font-extrabold text-xl tracking-tight text-foreground hidden sm:block">
            Detail<span className="text-primary">Book</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={`topnav-${link?.href}`}
              href={link?.href}
              className={`px-4 py-2 rounded-lg text-sm font-500 transition-colors ${
                pathname === link?.href
                  ? 'bg-secondary text-primary font-semibold' :'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/booking-management-dashboard"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5"
          >
            <Calendar size={15} />
            Staff Portal
          </Link>
          <Link
            href="/sign-up-login"
            className="btn-primary text-sm px-4 py-2 flex items-center gap-1.5"
          >
            <LogIn size={15} />
            Sign In
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-card animate-fade-in">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks?.map((link) => (
              <Link
                key={`mobile-nav-${link?.href}`}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  pathname === link?.href
                    ? 'bg-secondary text-primary font-semibold' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                {link?.label}
              </Link>
            ))}
            <hr className="border-border my-2" />
            <Link
              href="/booking-management-dashboard"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted flex items-center gap-2"
            >
              <Calendar size={15} />
              Staff Portal
            </Link>
            <Link
              href="/sign-up-login"
              onClick={() => setMobileOpen(false)}
              className="btn-primary text-sm mt-1 justify-center"
            >
              <LogIn size={15} />
              Sign In
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}